<template>
  <div class="select-client--container">
    <div class="shadow-card">
      <div>
        <label>Поиск клиента</label>
        <search-client v-model="clientSearch" :reset="reset"></search-client>
      </div>
      <div>
        <client-select-modification
          v-if="clientSearch"
          v-model="client_modification_id"
          :clientsModificationsRelations="clientSearch.clientsModificationsRelations"
        ></client-select-modification>
      </div>
      <div
        v-if="clientSearch && (+clientSearch.is_unwanted === 1 || clientSearch.is_unwanted === true)"
        class="text-small text-center text-danger"
      >
        Нежелательный клиент!
      </div>
      <div class="mrg-t-10">
        Имя клиента: <b>{{ selectedClientName }}</b> <br />
        Номер клиента: <b>{{ selectedClientNumber }}</b> <br /><br />
      </div>
    </div>

    <div class="mrg-t-15">
      <div class="shadow-card">
        <div v-if="fullConfig.company_config && fullConfig.company_config.add_field == 1" class="new-fast--addfield-line-form mrg-t-15">
          <div v-if="fullConfig.company_config && fullConfig.company_config.add_field_type == 0" class="input-block">
            <label>
              {{fullConfig.company_config.add_field_name}}
              <span v-if="fullConfig.company_config.add_field_required == 1" class="req">*</span>
            </label>
            <input type="text" v-model="addField">
          </div>
          <div v-if="fullConfig.company_config && fullConfig.company_config.add_field_type == 1" class="input-block">
            <label>
              {{fullConfig.company_config.add_field_name}}
              <span v-if="fullConfig.company_config.add_field_required == 1" class="req">*</span>
            </label>
            <textarea v-model="addField"></textarea>
          </div>
        </div>
        <div v-if="isNewEnroll" class="input-block mrg-t-15">
          <label for="add_enroll_comment">Комментарий к записи</label>
          <textarea
            type="text"
            rows="6"
            v-model="enrollComment"
            id="add_enroll_comment"
          ></textarea>
        </div>
      </div>

      <div class="shadow-card mrg-t-25">
        <div class="text-center text-hint">Статус записи</div>
        <div class="new-fast--confirm-line mrg-t-10">
            <div class="new-fast--status-flex">
              <div  @click="enrollConfirm = 0" class="item" :class="{'active': enrollConfirm == 0}">
                <div class="name">Новая</div>
                <div class="color">
                  <div class="circle-status circle-status-new"></div>
                </div>
              </div>
              <div @click="enrollConfirm = 1" class="item" :class="{'active': enrollConfirm == 1}">
                <div class="name">Подтвержденная</div>
                <div class="color">
                  <div class="circle-status circle-status-confirm"></div>
                </div>
              </div>
              <div @click="enrollConfirm = 2" class="item" :class="{'active': enrollConfirm == 2}">
                <div class="name">Выполненная</div>
                <div class="color">
                  <div class="circle-status circle-status-done"></div>
                </div>
              </div>
              <div @click="enrollConfirm = 3" class="item" :class="{'active': enrollConfirm == 3}">
                <div class="name">Отмененная</div>
                <div class="color">
                  <div class="circle-status circle-status-cancel"></div>
                </div>
              </div>
            </div>
        </div>
      </div>

      <div class="shadow-card mrg-t-25" v-if="isNewEnroll">
        <div class="text-center text-hint">Источник привлечения</div>
        <div class="input-block">
          <label for="client_source">Источник привлечения</label>
          <select :disabled="!checkPermission('edit_source_client')" v-model="source_client_id" id="client_source">
            <option value="0">Не выбран</option>
            <option v-for="item in sourceClient" :key="item.id" :value="item.id">
              {{item.name}}
            </option>
          </select>
          <div
            v-if="checkPermission('create_source_client') || checkPermission('delete_source_client')"
            @click="showAddSourcePopup"
            class="add-source"
          >
            Управление источниками
          </div>
        </div>
      </div>


      <div
          v-if="
            fullConfig.main_config &&
            fullConfig.main_config.remind_before_setting > 0 &&
            isNewEnroll
          "
          class="select-client--auto-remind shadow-card mrg-t-25"
      >
      <div class="hr-short mrg-t-10"><div></div></div>
      <div class="text-center text-hint">Автонапоминания</div>
      <!-- Хитрость. Если групповая, то точно не новая и наоборот для данного способа создания -->
        <auto-reminders
            :remind-setting="fullConfig.main_config.remind_before_setting"
            :remind-email="{}"
            :remind-sms="{}"
            :isNewEnroll="isNewEnroll"
            @change="selectRemindHour"
        ></auto-reminders>
      </div>


      <div v-if="sms.show" class="input-block shadow-card mrg-t-25">
        <label>
          <input type="checkbox" id="" v-model="sms.result" />
          Отправить клиенту СМС
        </label>
      </div>
      <div class="input-block text-right mrg-t-20">
        <div @click="createEnroll" class="btn btn-sm btn-info">
          Создать запись
        </div>
      </div>
    </div>

    <popup
      :closeButton="addSourcePopup.closeButton"
      :show="addSourcePopup.show"
      @closePopup="closeAddSourcePopup"
    >
      <div slot="header">Управление источниками привлечения</div>
      <div slot="body">
        <crud-source-client
          v-if="addSourcePopup.show"
          @updateSource="updateSourceClient"
        ></crud-source-client>
      </div>
    </popup>

  </div>
</template>

<script>
import SearchClient from "../../clients/SearchClient";
import AutoReminders from "@/components/panel/journal/AutoReminders";
import permissionMixin from "@/components/mixins/Permissions";
import Popup from "../../../Popup.vue";
import CrudSourceClient from '../../source_client/CrudSourceClient.vue';
import ClientSelectModification from '../../clients/ClientSelectModification.vue';
import configRepository from "../../../../repositories/config";
import sourceRepository from "../../../../repositories/source";


export default {
  name: "SelectClient",
  components: { AutoReminders, SearchClient, Popup, CrudSourceClient, ClientSelectModification },
  mixins: [permissionMixin],
  data() {
    return {
      clientSearch: null, // v-model
      addField: "", // model
      enrollComment: "", // model
      enrollConfirm: 1, // model
      source_client_id: '0', // model
      client_modification_id: 0, // model
      fullConfig: {},
      sms: {
        request: false,
        show: false,
        result: false
      },
      searchTimeout: false,
      remindHourModel: 0,
      sourceClient: [],
      addSourcePopup: {
        show: false,
        closeButton: "Отмена"
      },
    };
  },
  props: {
    reset: Number,
    show: Boolean,
    isGroup: Boolean
  },
  watch: {
    reset: function() {
      this.clientSearch = null;
      this.enrollComment = "";
      this.addField = "";
    },
    show: function(val) {
      if (val && !this.sms.request) {
        this.setSmsParams();
      }
      if(val && !this.fullConfig.main_config){
        this.getFullConfig();
      }
      if(val){
        this.source_client_id = '0';
        this.getSources();
      }
    }
  },
  computed: {
    isNewEnroll(){
      let result = true;
      if(this.isGroup){
        result = false;
      }
      return result;
    },
    selectedClientName() {
      let result = "";
      if (
        this.clientSearch != null &&
        typeof this.clientSearch.name !== "undefined"
      ) {
        result = this.clientSearch.name;
      }
      return result;
    },
    selectedClientNumber() {
      let result = "";
      if (
        this.clientSearch != null &&
        typeof this.clientSearch.number !== "undefined"
      ) {
        result = "+" + this.clientSearch.number;
      }
      return result;
    }
  },
  methods: {
    updateSourceClient(val){
      this.sourceClient = val;
    },
    showAddSourcePopup(){
      this.addSourcePopup.show = true;
    },
    closeAddSourcePopup(){
      this.addSourcePopup.show = false;
    },
    getSources(){
      sourceRepository.view().then(resp => {
        this.sourceClient = resp.data;
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
        this.$store.dispatch("stopPreloader");
      });
    },
    selectRemindHour(value){
      this.remindHourModel = value;
    },
    getFullConfig(){
      configRepository.fullConfigCurrentCompany().then(resp => {
        this.fullConfig = resp.data.result;
      }).catch(err => {
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
      });
    },
    setSmsParams() {
      this.$store.dispatch("startPreloader");

      configRepository.getByName({ name:  'sms_client_enroll' }).then(resp => {
        this.sms.request = true;
        if (+resp.data.result === 1) {
          this.sms.show = true;
          this.sms.result = false;
        } else {
          this.sms.show = false;
          this.sms.result = false;
        }
        this.$store.dispatch("stopPreloader");
      }).catch(err => {
        this.$store.dispatch("stopPreloader");
        this.$store.dispatch("addNotification", {
          text: err.response.data.message,
          time: 6,
          color: "danger"
        });
      });
    },
    createEnroll() {
      if (this.clientSearch == null) {
        this.$store.dispatch("addNotification", {
          text: "Не выбран клиент",
          time: 4,
          color: "danger"
        });
        return false;
      }
      if(this.fullConfig.company_config &&
          this.fullConfig.company_config.add_field == 1 &&
          this.fullConfig.company_config.add_field_required == 1 &&
          this.addField === '')
      {
        this.$store.dispatch("addNotification", {
          text: `Не заполнено поле "${this.fullConfig.company_config.add_field_name}"`,
          time: 3,
          color: "danger"
        });
        return false;
      }
      let params = {};
      params.number = this.clientSearch.number;
      params.comment = this.enrollComment;
      params.send_sms = this.sms.result;
      params.confirm = this.enrollConfirm;
      params.add_field = this.addField;
      params.remind_before_hour = this.remindHourModel;
      params.source_client_id = this.source_client_id;
      params.client_modification_id = this.client_modification_id;
      this.$emit("createEnroll", params);
    }
  },
  created() {}
};
</script>

<style scoped lang="less">
.new-fast--status-flex {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  flex-direction: row;

  & > .item {
    width: 140px;
    position: relative;
    padding: 10px;
    border: 1px solid rgb(202, 202, 202);
    border-radius: 8px;
    cursor: pointer;
    box-sizing: border-box;
    margin-top: 8px;

    .name{
      color: rgb(172, 172, 172);
      font-size: 13px;
    }
    .color{
      position: absolute;
      top: 3px;
      right: 3px;
      opacity: 0.5;
    }
  }
  & > .item.active{
    border: 1px solid #333;

    .name{
      color: #333;
      font-weight: 700;
      text-decoration: underline;
    }
    .color{
      opacity: 1;
    }
  }
}
.add-source{
  margin-top: 4px;
  font-size: 12px;
  text-decoration: underline dashed #0693e3;
  cursor: pointer;
  color: #0693e3;
}
.select-client--status-block {
  line-height: 35px;
}
.circle-status {
  display: inline-block;
  width: 17px;
  height: 17px;
  border-radius: 15px;
}
.circle-status-new {
  background-color: #ff3d3d;
}
.circle-status-confirm {
  background-color: #fecf63;
}
.circle-status-done {
  background-color: #36deac;
}
.circle-status-cancel {
  background-color: #6f03d3;
}
</style>
